import React from "react";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import { TinyMcePasteOption, htmlToPlainText } from "@/Contracts";
import ZModal from "@atoms/ZModal";
import ZRadioGroup from "@atoms/ZRadioGroup";
interface TinyMCEPastePromptContentProps {
	setPasteOption: (pasteOption: TinyMcePasteOption) => void;
}
const TinyMCEPrePastePromptContent: React.FC<
	TinyMCEPastePromptContentProps
> = ({ setPasteOption }) => {
	return (
		<Row>
			<Col span={24} className="mb-2">
				<div>
					You are trying to paste content with formatting which may
					not be supported in email clients like Outlook. We recommend
					using Zomentum's email editor for formatting your emails.{" "}
					<a
						href={
							"https://help.zomentum.com/support/solutions/articles/44002217411-email-rendering-issues-in-outlook"
						}
						rel="noreferrer"
						target="_blank"
					>
						Learn More
					</a>
				</div>
			</Col>
			<Col span={24}>
				<ZRadioGroup
					defaultValue={TinyMcePasteOption.PASTE_WITHOUT_FORMATTING}
					onChange={e => setPasteOption(e.target.value)}
					options={[
						{
							label: "Paste without Formatting",
							value: TinyMcePasteOption.PASTE_WITHOUT_FORMATTING
						},
						{
							label: "Paste with Formatting",
							value: TinyMcePasteOption.PASTE_WITH_FORMATTING
						}
					]}
					space="small"
					vertical
				/>
			</Col>
		</Row>
	);
};

function tinyMCEPastePreProcess(this: any, data: any) {
	let pasteOption = TinyMcePasteOption.PASTE_WITHOUT_FORMATTING;
	const setPasteOption = (option: TinyMcePasteOption) =>
		(pasteOption = option);
	if (data.source !== "plaintext" && data.source !== "text") {
		const content = data.content;
		ZModal.confirm({
			title: "Warning",
			content: (
				<TinyMCEPrePastePromptContent setPasteOption={setPasteOption} />
			),
			onOk: () => {
				pasteOption === TinyMcePasteOption.PASTE_WITHOUT_FORMATTING
					? this.insertContent(htmlToPlainText(content))
					: this.insertContent(content);
			}
		});
		data.content = "";
	}
}

export const initializeTinyMCEPrePastePrompt = (editor: any) => {
	editor.on("PastePreProcess", tinyMCEPastePreProcess.bind(editor));
};
